import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    boxShadow: 'none',
    borderRadius: 0,
    borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.16)}`,
    position: 'relative',
    textDecoration: 'none',
    '&:hover': {
      boxShadow: theme.shadows[2],
      zIndex: theme.zIndex.drawer,
    },
    '&:hover $closeNotification': {
      display: 'flex',
    },
  },
  header: {
    padding: theme.spacing(2, 2, 0, 2),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 3, 0, 4),
    },
  },
  providerIcon: {
    marginRight: theme.spacing(1),
  },
  providerIconNeutral: {
    color: theme.palette.primary.light,
  },
  providerIconPositive: {
    color: theme.palette.success.dark,
  },
  providerIconNegative: {
    color: theme.palette.error.main,
  },
  tag: {
    color: theme.palette.grey[200],
  },
  actionsNotification: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  closeNotification: {
    border: 'none',
    height: theme.spacing(3),
    width: theme.spacing(3),
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  iconCloseNotfication: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
  radio: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    color: theme.palette.primary.light,
  },
  content: {
    padding: theme.spacing(0.25, 2, 1.5, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0.25, 3, 1.5, 4),
    },
  },
  title: {
    color: theme.palette.grey[300],
  },
  text: {
    color: theme.palette.grey[200],
  },
  time: {
    color: theme.palette.grey[300],
  },
}))

export default useStyles
